// WeakSet, not a data-attribute — attributes get baked into innerHTML snapshots and wrongly mark fresh nodes as done.
window.searchProductsEmblaInitialized = window.searchProductsEmblaInitialized || new WeakSet();

window.initializeSearchProductsCarousel = function (root) {
  const scope = root || document;
  const emblaNode = scope.querySelector(".products-search-suggestions .search-products-embla");
  if (!emblaNode || window.searchProductsEmblaInitialized.has(emblaNode)) return;
  window.searchProductsEmblaInitialized.add(emblaNode);

  const prevBtn = scope.querySelector(".products-search-suggestions .embla__controls .prev-btn");
  const nextBtn = scope.querySelector(".products-search-suggestions .embla__controls .next-btn");
  const dotsNode = scope.querySelector(".products-search-suggestions .search-products-embla__dots");

  const options = {
    loop: false,
    align: "start",
    skipSnaps: false,
    containScroll: "trimSnaps",
    dragFree: false,
    slidesToScroll: 1,
  };
  const emblaApi = EmblaCarousel(emblaNode, options);

  if (prevBtn && nextBtn) {
    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) {
        prevBtn.removeAttribute("disabled");
      } else {
        prevBtn.setAttribute("disabled", "disabled");
      }

      if (emblaApi.canScrollNext()) {
        nextBtn.removeAttribute("disabled");
      } else {
        nextBtn.setAttribute("disabled", "disabled");
      }
    };

    prevBtn.addEventListener("click", () => emblaApi.scrollPrev(), false);
    nextBtn.addEventListener("click", () => emblaApi.scrollNext(), false);

    emblaApi
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState)
      .on("select", togglePrevNextBtnsState);
  }

  if (dotsNode) {
    let dots = [];

    const setActiveDot = () => {
      const selected = emblaApi.selectedScrollSnap();
      dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === selected);
      });
    };

    const buildDots = () => {
      dotsNode.innerHTML = "";
      dots = emblaApi.scrollSnapList().map((_, index) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "search-products-embla__dot";
        dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
        dot.addEventListener("click", () => emblaApi.scrollTo(index), false);
        dotsNode.appendChild(dot);
        return dot;
      });
      setActiveDot();
    };

    emblaApi
      .on("init", buildDots)
      .on("reInit", buildDots)
      .on("select", setActiveDot);
  }
};

window.initializeSearchProductsCarousel();
